import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-edit",
  "use": "rt-portal-edit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-edit\">\r\n<path d=\"M187.7,675.4c-12.6,15.6-18.7,34.8-17.2,54L112,912.1l182.7-58.5c19.2,1.5,38.4-4.5,53.5-17.2l5-1.5L188.7,670.4\r\n\tL187.7,675.4z M889.7,187.9l-54-54c-29.8-29.8-77.7-29.8-107.5,0l-52,52l161.5,161.5l52-52C919.4,265.6,919.4,217.7,889.7,187.9\r\n\tL889.7,187.9z M246.3,616.5L621,241.8l161.3,161.3L407.6,777.8L246.3,616.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/edit.svg
// module id = 1309
// module chunks = 91